import type { ConsultationKind } from "./schema";

export const CONSULTATION_KIND_LABEL: Record<ConsultationKind, string> = {
	online: "online",
	presential: "presencial",
};
